import React from "react";
import { useLocation } from "react-router-dom";
import PUBLIC_ROUTES from "../constants/public.routes";

/**
 * When the API reports a newer x-version, defer one hard reload so in-flight
 * work is not lost. Runs at most once per page load when the flag is set.
 */
export default function useVersionCheck() {
  const location = useLocation();
  const didReloadRef = React.useRef(false);

  React.useLayoutEffect(() => {
    if (didReloadRef.current) return;

    const shouldSkipReload =
      location?.state?.__skipVersionReload ||
      PUBLIC_ROUTES.some((path) => location.pathname.startsWith(path));

    if (shouldSkipReload) return;
    if (!window.localStorage.getItem("version-update-needed")) return;

    didReloadRef.current = true;
    window.localStorage.removeItem("version-update-needed");
    window.location.reload();
  }, [location]);
}
